import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Page} from "../../shared/model/core/page.model";
import {LocalityModel} from "../../modules/common/localization/locality/api/entity/locality.model";

@Injectable({
    providedIn: 'root'
})
export class LocalityService {

    constructor(private httpClient: HttpClient) { }

    findByZipCode(isoCodeCountry: string, zipcode: string, page: number, size: number): Promise<Page<LocalityModel>> {
        let url = environment.webserviceUrl + '/v1/countries/' + isoCodeCountry +'/localities'
            +'?page=' + page
            + '&size=' + size
            + '&sortBy=zipCode:asc'
            + '&zipCode=like:' + zipcode + '%25';
        return this.httpClient
            .get<Page<LocalityModel>>(url)
            .toPromise();
    }

    findByName(isoCodeCountry: string, name: string, page: number, size: number): Promise<Page<LocalityModel>> {
        let url = environment.webserviceUrl + '/v1/countries/' + isoCodeCountry +'/localities'
            +'?page=' + page
            + '&size=' + size
            + '&sortBy=name:asc'
            + '&name=like:' + name + '%25';
        return this.httpClient
            .get<Page<LocalityModel>>(url)
            .toPromise();
    }
}

